
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.574 9.965a.028.028 0 01-.018-.026.028.028 0 01.018-.026c2.34-1.2 2.76-3.856 1.543-4.736-1.35-.972-3.01.168-3.346.4a.028.028 0 01-.044-.028c.569-3.547-2.653-6.54-6.532-5.24C1.659 1.839 3.39 7.442 3.69 8.342a.029.029 0 01-.03.044.029.029 0 01-.018-.012c-1.37-1.264-4.692.316-3.314 4.708.93 2.947 4.38 3.263 6.572 3.263h.377a23.521 23.521 0 00-.4 3.656h3.55a20.757 20.757 0 01-.75-3.656h1.05c1.386 0 4.484-.248 5.858-2.236 2.084-3.02-.492-4.363-2.011-4.143z","fill":"currentColor"}})])
          )
        }
      }
    